import type { RohsComponentComplianceFileDetailView } from '@/shared/hooks/api/rohsComplianceFiles'
import type { ComponentRohsBriefingStep } from '@/shared/briefing/buildComponentRohsBriefing'
import { V2ComponentRohsComplianceSlotStep } from './V2ComponentRohsComplianceSlotStep'

export function V2ComponentRohsDrawingsStep({
  step,
  index,
  componentId,
  file,
  canWrite,
}: {
  step: ComponentRohsBriefingStep
  index: number
  componentId: string
  file: RohsComponentComplianceFileDetailView
  canWrite: boolean
}) {
  return (
    <V2ComponentRohsComplianceSlotStep
      step={step}
      index={index}
      componentId={componentId}
      file={file}
      slotKind='DRAWINGS_SCHEMAS'
      canWrite={canWrite}
    />
  )
}
